import React, { useState, useEffect } from "react";
import FadeContainer from "./FadeContainer";
import PricingHeader from "./PricingHeader";
import StripeSection from "./StripeSection";
import { useRouteMatch, useHistory } from "react-router-dom";
import { connect } from "react-redux";

function BillingInfo({
  open,
  handleClose,
  currency,
  vehiclesCount,
  setLoading,
  payment
}) {
  const match = useRouteMatch("/payment/:planId/billing");
  const match_editing = useRouteMatch("/payment/edit-payment-method");
  const history = useHistory();
  const [isEditing, setEditing] = useState(false);

  useEffect(() => {
    // Check from given history state value, if user is editing payment
    if (
      localStorage.subscription_id &&
      localStorage.customer_id &&
      !(history.location.state && history.location.state.action === "edit")
    ) {
      history.push("/payment/select-plan");
    } else {
      if (match_editing && match_editing.isExact) {
        setEditing(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FadeContainer open={open}>
      <PricingHeader
        title={
          isEditing
            ? payment
              ? "Edit payment method"
              : "Add payment method"
            : "Enter billing details"
        }
        handleClose={handleClose}
      />
      <StripeSection
        planName={match && match.params.planId}
        currency={currency}
        vehiclesCount={vehiclesCount}
        setLoading={setLoading}
        isEditing={isEditing}
        handleClose={handleClose}
      />
    </FadeContainer>
  );
}

const mapStateToProps = state => ({
  payment: state.account.payment
});

export default connect(mapStateToProps)(BillingInfo);
